module.exports = __webpack_public_path__ + "LogoLaLuneSittersvector_whitefill.svg?4853a280cdab4caa14dd3f4ef6b4869e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/LogoLaLuneSittersvector_whitefill.svg
// module id = 39
// module chunks = 0